export type {StatComparison} from './dashboard-comparison'

export type DashboardStatCardData = {
    title: string
    value: string | null
    comparison?: StatComparison
    comparisonLabel?: string
    isLoading: boolean
    isError: boolean
    error: unknown
    onRetry?: () => void
}

export type WorkerUtilizationRow = {
    workerTypeId: string
    typeName: string
    total: number
    onJobs: number
}

export type EquipmentUtilizationRow = {
    rentalAssetTypeId: string
    typeName: string
    total: number
    utilized: number
    available: number
}

export const WORKERS_UTILIZATION_HELP_TEXT =
    'Each color is a worker type (drivers, technicians, and so on). Colored sections are on a job today. Gray is everyone else who is available.'

export const EQUIPMENT_UTILIZATION_HELP_TEXT =
    'Each color is an equipment type. Colored sections are on a job today or already out in the field. Gray is in the yard with nothing scheduled—capacity you can sell.'
